import React from 'react';
import Sidebar from '@/components/Sidebar';
import { useAuth } from '@/components/auth/AuthContext';
import { Navigate } from 'react-router-dom';
import { toast } from 'sonner';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const { user, profile, loading } = useAuth();

  // Check if user is an admin using the is_admin field from profile
  const isAdmin = profile?.is_admin === true;

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-8 h-8 border-4 border-roundone-purple border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  // Redirect non-admin users
  if (!user || !isAdmin) {
    toast.error('You do not have admin access');
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="flex h-screen bg-background">
      <Sidebar />
      <main className="flex-1 overflow-y-auto">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
